import { render, staticRenderFns } from "./LayoutIosStatusBar.vue?vue&type=template&id=bc2182d2&scoped=true&"
import script from "./LayoutIosStatusBar.vue?vue&type=script&lang=js&"
export * from "./LayoutIosStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutIosStatusBar.vue?vue&type=style&index=0&id=bc2182d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2182d2",
  null
  
)

export default component.exports